import { MEAL_CONFIG } from "./nutritionConstants";
import { MacroDonut } from "./MacroDonut";

export function MacrosDashboard({ mealMacros, dayTotals, ebTargets, getMealName, L }) {
  return (
    <div className="bg-white rounded-xl border border-slate-200 p-4 mb-6" data-testid="macros-dashboard">
      <div className="flex items-center justify-between mb-3">
        <h2 className="text-sm font-bold text-slate-800">Makronährstoffe pro Mahlzeit</h2>
        <div className="flex items-center gap-3 text-[10px]">
          <span className="flex items-center gap-1"><span className="w-2 h-2 rounded-full bg-blue-500" />Protein</span>
          <span className="flex items-center gap-1"><span className="w-2 h-2 rounded-full bg-amber-500" />Kohlenhydrate</span>
          <span className="flex items-center gap-1"><span className="w-2 h-2 rounded-full bg-rose-500" />Fett</span>
        </div>
      </div>
      <div className="flex justify-between items-start">
        {MEAL_CONFIG.map(mc => {
          const m = mealMacros[mc.id] || { calories: 0, protein: 0, carbs: 0, fat: 0 };
          return <MacroDonut key={mc.id} label={getMealName(mc)} calories={m.calories} protein={m.protein} carbs={m.carbs} fat={m.fat} color={mc.color} size={110} pL={L.pAbbr} kL={L.kAbbr} fL={L.fAbbr} />;
        })}
      </div>
      <div className="mt-4 flex flex-col gap-2" data-testid="day-totals">
        {ebTargets && ebTargets.targetKcal > 0 && (
          <div className="relative h-2 bg-slate-200 rounded-full overflow-hidden">
            <div
              className={`h-full rounded-full transition-all duration-500 ${
                dayTotals.calories > ebTargets.targetKcal * 1.05 ? 'bg-rose-500' :
                dayTotals.calories >= ebTargets.targetKcal * 0.9 ? 'bg-emerald-500' : 'bg-amber-400'
              }`}
              style={{ width: `${Math.min((dayTotals.calories / ebTargets.targetKcal) * 100, 100)}%` }}
            />
          </div>
        )}
        <div className="flex items-center justify-center gap-6 bg-slate-900 text-white rounded-lg px-6 py-2.5">
          <span className="text-xs font-bold uppercase tracking-wider">{L.dayTotal}</span>
          <span className="text-sm font-bold">
            {dayTotals.calories.toFixed(0)}
            {ebTargets && ebTargets.targetKcal > 0 && (
              <span className="text-slate-400 font-normal"> / {Math.round(ebTargets.targetKcal)}</span>
            )}
            <span className="text-xs font-normal ml-0.5">kcal</span>
          </span>
          <span className="text-xs text-blue-300">
            {L.pAbbr}: {dayTotals.protein.toFixed(1)}
            {ebTargets && ebTargets.targetProteinG > 0 && <span className="text-blue-400/60">/{Math.round(ebTargets.targetProteinG)}</span>}g
          </span>
          <span className="text-xs text-amber-300">
            {L.kAbbr}: {dayTotals.carbs.toFixed(1)}
            {ebTargets && ebTargets.targetCarbsG > 0 && <span className="text-amber-400/60">/{Math.round(ebTargets.targetCarbsG)}</span>}g
          </span>
          <span className="text-xs text-rose-300">
            {L.fAbbr}: {dayTotals.fat.toFixed(1)}
            {ebTargets && ebTargets.targetFettG > 0 && <span className="text-rose-400/60">/{Math.round(ebTargets.targetFettG)}</span>}g
          </span>
        </div>
      </div>
    </div>
  );
}
